<sm-table *ngIf="inited" [data]="table" [allowExport]="false" (onRowSelect)="selectRow($event)">
</sm-table>
